"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeOrmConfig = void 0;
const environment_1 = require("../environment");
const entities_1 = require("../entities");
exports.typeOrmConfig = {
    type: environment_1.ENV.DB_TYPE || "postgres",
    host: environment_1.ENV.DB_HOST,
    port: environment_1.ENV.DB_PORT ? parseInt(environment_1.ENV.DB_PORT, 10) : 5432,
    username: environment_1.ENV.DB_USER,
    password: environment_1.ENV.DB_PASSWORD,
    database: environment_1.ENV.DB_NAME,
    entities: [...entities_1.entities],
    synchronize: false,
    logging: environment_1.ENV.DB_LOGGING ? environment_1.ENV.DB_LOGGING.split(",") : false
};
